/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Makes text shortened with '...' at the end.
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.0
 */
import styled from 'styled-components';

interface IEllipsisTextStyled {
    lines?: number;
}

export const EllipsisTextStyled = styled.div<IEllipsisTextStyled>`
    display: inline-block;
    width: inherit;
    min-width: 0;
    max-width: inherit;
    text-overflow: ellipsis;
    white-space: ${props => props.lines ? 'unset' : 'nowrap'};
    overflow: hidden;

    ${props => props.lines && `
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${props.lines};
    `}
`;
